import React from 'react';
import thumbnail from './material/thumbnail.png';
import chi2025 from './material/chi2025.svg';

const debateGenAI2025 = {
  id: 'debategenai-2025',
  year: 2025,
  title: <>&ldquo;Ronaldo&rsquo;s a poser!&rdquo;: How the Use of Generative AI Shapes Debates in Online Forums</>,
  authors: [
    { name: 'Yuhan Zeng', suffix: '*' },
    { name: 'Yingxuan Shi', suffix: '*' },
    { name: 'Xuehan Huang', suffix: '*' },
    { name: 'Fiona Nah', url: 'https://faculty.smu.edu.sg/profile/nah-fiona-fui-hoon-7861' },
    { name: 'RAY LC', url: 'https://www.scm.cityu.edu.hk/people/ray-lc' },
  ],
  thumbnail,
  keywords: ['Co-Writing', 'AI-Mediated Communication', 'Human-AI Collaboration', 'Online Debate', 'Remote Collaboration', 'Generative AI', 'Large Language Models'],
  awards: [],
  links: [
    { label: '[Paper]', url: 'https://doi.org/10.1145/3706598.3713829' },
    { label: '[arXiv]', url: 'https://arxiv.org/abs/2502.09693v2' },
  ],
  venue: 'ACM CHI 2025',
  fullVenue: 'The ACM CHI Conference on Human Factors in Computing Systems',
  venueLogo: chi2025,
};

export default debateGenAI2025;